import { getOptionalProperty, getRequiredProperty, } from '@synisys/idm-dynamic-layout-interpreter';
import { endsWith, split, includes, isNil } from 'lodash';
var FieldPostFix;
(function (FieldPostFix) {
    FieldPostFix["NAME"] = "-name";
    FieldPostFix["CATEGORY"] = "-category";
    FieldPostFix["ID"] = "-id";
    FieldPostFix["PARENT"] = "-parent";
    FieldPostFix["PARENT_NAME"] = "-parent-name";
    FieldPostFix["PARENT_CATEGORY"] = "-parent-category";
    FieldPostFix["PARENT_ID"] = "-parent-id";
})(FieldPostFix || (FieldPostFix = {}));
var FieldArgument = /** @class */ (function () {
    function FieldArgument(arg) {
        this.value = arg;
    }
    FieldArgument.prototype.resolve = function (controlModel, contextEntity, parentFieldFinder) {
        return this.resolveByPostFix(controlModel, contextEntity, parentFieldFinder);
    };
    FieldArgument.prototype.resolveByPostFix = function (controlModel, contextEntity, parentFieldFinder) {
        var fieldKey = this.getFieldKey(controlModel);
        if (controlModel.fields[fieldKey]) {
            if (endsWith(this.value, FieldPostFix.PARENT)) {
                var parentField = parentFieldFinder(controlModel.fields[fieldKey]);
                return !isNil(parentField) ? contextEntity + ".getProperty('" + getOptionalProperty(parentField, 'metaFieldId.systemName') + "').value" : undefined;
            }
            else if (endsWith(this.value, FieldPostFix.PARENT_CATEGORY)) {
                var parentField = parentFieldFinder(controlModel.fields[fieldKey]);
                return !isNil(parentField) ? "'" + getOptionalProperty(parentField, 'compoundCategorySystemName') + "'" : undefined;
            }
            else if (endsWith(this.value, FieldPostFix.PARENT_NAME)) {
                var parentField = parentFieldFinder(controlModel.fields[fieldKey]);
                return !isNil(parentField) ? "'" + getRequiredProperty(parentField, 'metaFieldId.systemName') + "'" : undefined;
            }
            else if (endsWith(this.value, FieldPostFix.PARENT_ID)) {
                var parentField = parentFieldFinder(controlModel.fields[fieldKey]);
                return !isNil(parentField) ? contextEntity + ".getProperty('" + getOptionalProperty(parentField, 'metaFieldId.systemName') + "').value === null ? null :\n                     " + contextEntity + ".getProperty('" + getRequiredProperty(parentField, 'metaFieldId.systemName') + "').value.getId()" : undefined;
            }
            else if (endsWith(this.value, FieldPostFix.NAME)) {
                return "'" + getRequiredProperty(controlModel.fields[fieldKey], 'metaFieldId.systemName') + "'";
            }
            else if (endsWith(this.value, FieldPostFix.CATEGORY)) {
                return "'" + getOptionalProperty(controlModel.fields[fieldKey], 'compoundCategorySystemName') + "'";
            }
            else if (endsWith(this.value, FieldPostFix.ID)) {
                return contextEntity + ".getProperty('" + getOptionalProperty(controlModel.fields[fieldKey], 'metaFieldId.systemName') + "').value === null ? null :\n          " + contextEntity + ".getProperty('" + getRequiredProperty(controlModel.fields[fieldKey], 'metaFieldId.systemName') + "').value.getId()";
            }
            else {
                return contextEntity + ".getProperty('" + getOptionalProperty(controlModel.fields[fieldKey], 'metaFieldId.systemName') + "').value";
            }
        }
        return '';
    };
    FieldArgument.prototype.getFieldKey = function (controlModel) {
        var key = split(this.value, '-', 1)[0];
        if (includes(key, '|')) {
            var keys = split(key, '|');
            var result = keys.find(function (kkey) { return controlModel.fields.hasOwnProperty(kkey); });
            if (isNil(result)) {
                throw new TypeError("There is no field in " + controlModel.selector + " with name " + key + ".");
            }
            return result;
        }
        else {
            if (!controlModel.fields.hasOwnProperty(key)) {
                throw new TypeError("There is no field in " + controlModel.selector + " with name " + key + ".");
            }
            return key;
        }
    };
    return FieldArgument;
}());
export { FieldArgument };
//# sourceMappingURL=field-argument.js.map